import { Action } from 'redux';

import { ShareContent } from '../../app/actions/AppActionTypes';
import { isActionFactory } from '../../app/actions/isActionFactory';
import { IContentInfo } from '../../spacesPlatform/models/IContentInfo';

export interface ShareContentAction extends Action {
  content: IContentInfo;
}

export function shareContent(content: IContentInfo): ShareContentAction {
  return {
    type: ShareContent,
    content
  };
}

export const isShareAction = isActionFactory<ShareContentAction>(ShareContent);
